<template>

  <div class="card mb-4 shadow-sm border-radius-xl">
    <div class="card-header pb-0 bg-transparent border-bottom-0">
      <div class="row align-items-center">
        <div class="col">
          <h6 class="font-weight-bolder mb-0 text-uppercase">
            <font-awesome-icon icon="list" class="text-primary me-2" />
            Lista de SMS Enviados
          </h6>
          <p class="text-sm mb-0">Historial completo de mensajes enviados por el sistema</p>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
      <div class="row mb-3 align-items-center">
        <div class="col-md-3">
          <div class="form-group mb-0">
            <select name="per_page" id="per_page" v-model="pagination.limit" class="form-control form-control-sm" @change="reloadPaginate(1)">
              <option value="20">20 por página</option>
              <option value="50">50 por página</option>
              <option value="100">100 por página</option>
              <option value="200">200 por página</option>
            </select>
          </div>
        </div>
        <div class="col-md-5 ms-auto">
          <div class="input-group input-group-sm shadow-none border-radius-md">
            <span class="input-group-text bg-white border-end-0">
              <font-awesome-icon icon="search" class="text-muted" />
            </span>
            <input type="text" class="form-control border-start-0" placeholder="Buscar por usuario, email o mensaje..." v-model="pagination.search" @keyup="manualSearch">
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Destino</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Agente</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Mensaje</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Estado</th>
            </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in arraySms" :key="index">
            <td class="text-uppercase text-xs font-weight-bold mb-0">{{item.user}}</td>
            <td class="text-uppercase text-xs font-weight-bold mb-0">{{item.to}}</td>
            <td class="text-uppercase text-xs font-weight-bold mb-0"><span v-if="item.agent">{{item.agent.name}}</span></td>
            <td class="text-uppercase text-xs font-weight-bold mb-0">
              <div class="limited-width_30">
                {{item.message}}
              </div>
            </td>
            <td class="align-middle">
              <p class="text-xs font-weight-bold mb-0 px-3">{{$filters.formatDate(item.created_at)}}</p>
            </td>
            <td class="align-middle text-center">
              <div v-b-tooltip.hover :title="item.response.text??item.response.message">
                <span class="badge badge-sm" :class="item.response.status === 'success'? 'bg-gradient-success':'bg-gradient-danger'">
                  {{ item.response.status === "success" ? "EXITOSO" : "ERROR" }}
                </span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between align-items-center mt-3">
          <div>
            <p class="text-xs text-muted mb-0">Total: {{pagination.totalRows}} registros</p>
          </div>
          <div>
            <v-pagination
                v-model="pagination.page"
                :pages="pagination.pages"
                :range-size="1"
                active-color="#82d616"
                @update:modelValue="reloadPaginate"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get} from "@/utils/httpRequest";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faList, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faList, faSearch);

export default {
  name: "SmsList",
  components: {
    FontAwesomeIcon
  },
  data: () => ({
    arraySms: [],
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 20,
      search: '',
      totalRows: 0
    },
    sms: {
      user: '',
      to: '',
      message: ''
    }
  }),
  mounted() {
    this.getSms()
  },
  methods: {
    async getSms(){
      const {data} = await get(`sms/find-all-sms?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${this.pagination.search}`)
      this.arraySms = data.docs
      this.pagination.totalRows = data.count
      this.pagination.page = data.page
      this.pagination.pages = data.pages
    },
    reloadPaginate(page){
      this.pagination.page = page
      this.getSms()
    },
    manualSearch(){
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1)
      }, 2000);
    },
  }
}
</script>

<style scoped>

</style>
